<div class='container-float'>

  <b-row class="mb-3">
    <b-col cols="12">
      &nbsp;
    </b-col>
  </b-row>

  <b-alert v-model="showAlert" variant="warning" dismissible>
    {{ alertMsg }}
  </b-alert>

  <b-modal v-model="showModal" ref="delete" id="delete" title="Conferma cancellazioe" @ok="handleDelete" @cancel="handleCancel">
    <h3>Sei sicuro di voler cancellare la riga?</h3>
  </b-modal>

  <b-row class="mb-3">
    <b-col cols="12">

      <b-card
        title="Tipologie di Tipi Merci"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="3">
              <span class='label'>
                Tipologia
              </span>
            </b-col>
            <b-col cols=8>
              <span class='label'>
                Descrizione
              </span>
            </b-col>
            <b-col cols=1>
              Attiva
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <b-form-input v-model="selectedKind.kind" class=""></b-form-input>
            </b-col>
            <b-col cols="8">
              <b-form-input v-model="selectedKind.description" class=""></b-form-input>
            </b-col>
            <b-col cols=1>
              <b-form-checkbox v-model="selectedKind.active"></b-form-checkbox>
            </b-col>
          </b-row>            

          <b-row>
            <b-col cols="12">
              &nbsp;
            </b-col>          
          </b-row>
          <b-row>
            <b-col cols="2">
              <b-button variant="warning" @click="cancelGoodKinds">Annulla</b-button>
            </b-col>          
            <b-col cols="7">
              &nbsp;
            </b-col>          
            <b-col cols="2">
              <b-button v-if="!current_id" variant="primary" @click="insertGoodKinds">Inserisci</b-button>
              <b-button v-if="current_id" variant="success" @click="updateGoodKinds">Aggiorna</b-button>
            </b-col>          
            <b-col cols="1">
              &nbsp;
            </b-col>          
          </b-row>
        </b-card-body>
      </b-card>

      <b-card
        title="Lista Tipologie di Tipi di Merce"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="12">
              <table class="">
                <thead>
                  <th style="width: 0%;"></th>
                  <th style="width: 20%;">Tipologia</th>
                  <th style="width: 70%;">Descrizione</th>
                  <th style="width: 5%;">Attiva</th>
                  <th style="width: 5%;"></th>
                </thead>
                <tbody>
                  <tr v-for="kind in paginatedKinds" :key="kind.id" class="row-selection">
                    <td @click="editRow(kind)"  style="visibility: hidden;">{{ kind.id }}</td>
                    <td @click="editRow(kind)" >{{ kind.kind }}</td>
                    <td @click="editRow(kind)" >{{ kind.description }}</td>
                    <td @click="editRow(kind)">
                      <i v-if="kind.active" class="fas fa-check" style="color: green;"></i>
                      <!-- <b-form-checkbox v-model="kind.active" @input="changeStatus(kind, $event)"></b-form-checkbox> -->
                    </td>
                    <td><i class="fas fa-trash" @click="deleteRecord(kind.id)" style="pointer: cursor !important;"></i></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="10">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="my-table"
                @change="onPageChange"
                class="my-3"
              ></b-pagination>            
            </b-col>
            <b-col cols="2">
              <span>Pagina {{ currentPage }} di {{ totalPages }} pagine</span>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>


</div>